import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';
import auth from './auth';
import calculator from './calculator';
import mortgage from './mortgage';
import budget from './budget';
import prosperity from './prosperity';

// const apiHost = process.env.REACT_APP_API_HOST ? process.env.REACT_APP_API_HOST : 'https://devwww.libro.ca';
// const apiURL = `${apiHost}/api/calculator`;

const configuredApiHost = process.env.REACT_APP_API_HOST ? process.env.REACT_APP_API_HOST : 'https://www.libro.ca';

// If the page is served from the same site as the API but on the other side of
// the www/non-www split (e.g. https://libro.ca vs https://www.libro.ca), use the
// page's own origin so requests stay same-origin and don't trip CORS.
const resolveApiHost = configured => {
    try {
        const { hostname, origin } = window.location;
        const configuredHostname = new URL(configured).hostname;
        const bareHost = host => host.replace(/^www\./, '');
        if (hostname !== configuredHostname && bareHost(hostname) === bareHost(configuredHostname)) {
            return origin;
        }
    } catch (e) {
        // Fall through to the configured host
    }
    return configured;
};

const apiHost = resolveApiHost(configuredApiHost);
const apiURL = `${apiHost}/wp-json/libro/v1/calculator`;

export const authURL = `${apiURL}/auth`;

export const mortgageTerms = `${apiURL}/mortgage/terms`;
export const mortgageContact = `${apiURL}/mortgage/contact`;

export const budgetContact = `${apiURL}/budget/contact`;

export const prosperityContact = `${apiURL}/prosperity/contact`;

export const getTeamMember = `${apiURL}/team/member`;

export const saveCalculatorDraft = `${apiURL}/save-draft`;

export const navigationHTML = `${apiURL}/navigation`;

// Standalone, scoped (.libro-main-nav) stylesheet built from the main theme's
// header SCSS. Served from the WP origin so root-relative url() assets resolve.
export const navigationCSS = `${apiHost}/themes/theme/styles/nav-standalone.css`;

// Standalone nav behaviour bundle (header + search) built from the main theme's
// own JS. Exposes window.libroNav.{initHeader,initSearch}. Sourced from WP so it
// stays in sync with the main site rather than being copied into this repo.
export const navigationJS = `${apiHost}/themes/theme/scripts/nav-standalone.js`;

// Logger endpoints
const loggerApiURL = `${apiHost}/wp-json/libro/v1/logger`;
export const loggerAuthUrl = `${loggerApiURL}/auth`;
export const loggerEndpoint = `${loggerApiURL}/save`;

export default combineReducers({
    auth,
    form,
    calculator,
    mortgage,
    budget,
    prosperity
});
